<script>
  import { isActive } from '@sveltech/routify'
  import configuration from '../../config.json'

  $: links = configuration.links && configuration.links.length ? configuration.links.map(l => ({
    ...l,
    active: $isActive(l.url)
  })) : [];

</script>

<nav class="navigation">
  <div class="logo">
    <a href="/">
      <img src="/static/company-info-no-text.png" alt="company.info" width="201" height="39" />
    </a>
  </div>
  <div class="menu">
    {#each links as link}
      <a href={link.url} target={link.target} class:active={link.active}>{link.text}</a>
    {/each}
  </div>
</nav>

<style type="text/scss">
  .navigation {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: $pageWidth;
    height: $navHeight;
    margin: 0 auto;
    padding: 0 $pagePadding;
    box-sizing: border-box;

    .logo a {
      display: flex;
    }

    .menu {
      display: flex;
      flex: 1 1 auto;
      margin: 0 50px;

      > a {
        @include navigation-item;
      }

      .active {
        @include activeNavLink();
      }
    }
  }
</style>